import React from "react";
import CustomModal from "../custom-modal/custom-modal";
import "./logs-modal.scss";

interface LogsModalProps {
  isVisible: boolean;
  onClose: () => void;
  logs: string;
  title?: string;
}

const LogsModal: React.FC<LogsModalProps> = ({
  isVisible,
  onClose,
  logs,
  title = "Logs Details"
}) => {
  const formatLogs = (logsText: string) => {
    if (!logsText) return [];
    
    return logsText.split('\n').filter(log => log.trim() !== '');
  };

  const getLogType = (log: string) => {
    if (log.toLowerCase().includes('failed')) return 'error';
    if (log.toLowerCase().includes('success')) return 'success';
    if (log.toLowerCase().includes('exists')) return 'warning';
    return 'info';
  };

  const getLogIcon = (type: string) => {
    switch (type) {
      case 'error':
        return '❌';
      case 'success':
        return '✅';
      case 'warning':
        return '⚠️';
      default:
        return 'ℹ️';
    }
  };

  return (
    <CustomModal
      isVisible={isVisible}
      onClose={onClose}
      width={600}
      centered={true}
      className="logs-modal"
      showClose={false}
    >
      <div className="logs-modal-container">
        <div className="modal-header">
          <h3>{title}</h3>
          <p>Review the detailed logs for this upload</p>
        </div>
        
        <div className="logs-content">
          {formatLogs(logs).length > 0 ? (
            <div className="logs-list">
              {formatLogs(logs).map((log, index) => {
                const logType = getLogType(log);
                const logIcon = getLogIcon(logType);
                
                return (
                  <div key={index} className={`log-item ${logType}`}>
                    <div className="log-icon">{logIcon}</div>
                    <div className="log-text">{log}</div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="no-logs">
              <p>No logs available</p>
            </div>
          )}
        </div>
        
        <div className="modal-footer">
          <button className="close-btn" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </CustomModal>
  );
};

export default LogsModal; 